import { useState } from 'react';

import { convertDateToQueryString } from './useAisleContentQueryParams';

/**
 * Manages date selection.
 *
 * @param {Date} initialDate - The initially selected date
 * @param {Function} updateQueryParams - Callback function to update the query parameters
 */
export function useDateSelection(initialDate, updateQueryParams) {
    const [date, setDate] = useState(initialDate);
    const [datePopoverOpen, setDatePopoverOpen] = useState(false);

    const handleSelectDate = (newDate) => {
        setDate(newDate);
        setDatePopoverOpen(false);
        updateQueryParams({ date: convertDateToQueryString(newDate) });
    };

    return { date, datePopoverOpen, handleSelectDate, setDatePopoverOpen };
}
